import React from 'react';
import styles from './TextEffects3d.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

export type TextEffects3dProps = TextEffectsSharedProps;

const TextEffects3d: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={() => ({
          className: styles.container,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <span className={styles.block} data-testid={TestIds.viewer.text}>
            {data}
          </span>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffects3d;
